module.exports = __webpack_public_path__ + "img/banner2.f5c233b4.png";